import api from "./api";

// New-customer onboarding progress. Kept on the server, not in the browser, so
// the administrator resumes on the same step after closing the app or signing
// in again (possibly from another machine).
const get = () => {
  return api.get("/api/onboarding/get");
};

// `answers` is merged server-side, so a step only sends its own slice.
const save = ({ currentStep, answers, completed }) => {
  return api.post("/api/onboarding/save", { currentStep, answers, completed });
};

const OnboardingService = {
  get,
  save,
};

export default OnboardingService;
